import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import PurchaseOrderService from "../../Controller/PurchaseOrderController";
import { handleChange, handleSubmit } from "../../Controller/UpdateOtherInfoController";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import HelpSite from "../../../Common/HelpLink";
import { quillModules, quillFormats, addToolbarTitles } from "../../../Common/quillConfig";
import SunTextEditor from "../../../Common/SunTextEditor";
function PurchaseOrderOtherInformation({ PurchaseOrderID }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        vc_Notes: "",

    });
    const { theme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    useEffect(() => {

        if (PurchaseOrderID > 0) {
            fetchPurchaseOrderDetail();
        }
        else {
            resetForm();
        }
    }, [PurchaseOrderID]);

    const fetchPurchaseOrderDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (PurchaseOrderID > 0) {
                const purchaseOrderDetail = await PurchaseOrderService.GetPurchaseOrderByID(redirectCallback, PurchaseOrderID);
                const purchaseOrder = purchaseOrderDetail[0];
                setFormData({
                    ...purchaseOrder,
                });
            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    const handleFormSubmit = async (event) => {
        event.preventDefault();

        try {
            const redirectUserList = () => {
                navigate('/QuotationsList?saved=true');
            };
            debugger;
            const message = await handleSubmit(event, formData, setFormData, setErrors);
            if (message == "Data saved successfully") {
                setShowSuccessMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowSuccessMessage(false);
                }, 5000);
            }
            else {
                setShowErrorMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowErrorMessage(false);
                }, 5000);

            }
            fetchPurchaseOrderDetail();
        } catch (error) {
            console.error('Error submitting form:', error);
            setErrors({ submit: 'An error occurred while submitting the form. Please try again.' });
        }
    };
    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };
    const resetForm = () => {

        setFormData({
            vc_Notes: "",

        });
    };
    const handleEditorChange = (content) => {
        setFormData({
            ...formData,
            vc_Notes: content
        });
    };

    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                <div className="col-xl-12" style={{ "textAlign": "right" }}>
                    
                </div>
            </div>
            <form onSubmit={handleFormSubmit}>
                <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                    <label htmlFor="vc_Notes" className="col-sm-1 col-form-label">Notes:</label>
                    <div className="col-sm-11">
                        <SunTextEditor
                            value={formData.vc_Notes}
                            onChange={(content) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    vc_Notes: content,
                                }))
                            }
                        />
                        {errors.vc_Notes && <div style={{ color: 'red' }}>{errors.vc_Notes}</div>}
                    </div>
                </div>

                <div className="row" style={{ "marginLeft": "0px", "float": "right" }}>
                    <div className="col-sm-12">
                        <button type="submit" className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`}>
                             <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} /> Save
                        </button>

                    </div>
                </div>
            </form>


        </div>


    );
}
export default PurchaseOrderOtherInformation;

